import React, { useState } from "react";
import { MdLanguage } from "react-icons/md";
import { useTranslation } from "react-i18next";

const LanguageSwitcher = () => {
    const { i18n } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
        setIsOpen(false); // إغلاق القائمة بعد اختيار اللغة
    };

    console.log("Current Language:", i18n.language); // تحقق من اللغة الحالية في وحدة التحكم

    return (
        <div className="relative">
            {/* زر تغيير اللغة */}
            <button
                onClick={toggleDropdown}
                className="text-xl bg-black w-10 h-10 flex items-center justify-center rounded-full text-designColor cursor-pointer transition-all duration-300 hover:bg-gray-800"
                title="Change Language"
            >
                <MdLanguage style={{ fontSize: "21px" }} />
            </button>

            {/* القائمة المنبثقة */}
            {isOpen && (
                <div className="absolute left-1/2 transform  mt-2 w-28 bg-black text-white rounded-lg shadow-lg py-2 z-50" style={{translate : i18n.language === 'en' ? '-85px' : '-25px'}}>
                    <button
                        onClick={() => changeLanguage("ar")}
                        className="block w-full text-center px-4 py-2 text-sm hover:text-[#ff014f] transition-all duration-200"
                    >
                        عربي
                    </button>
                    <button
                        onClick={() => changeLanguage("en")}
                        className="block w-full text-center px-4 py-2 text-sm hover:text-[#ff014f] transition-all duration-200"
                    >
                        English
                    </button>
                </div>
            )}
        </div>
    );
};

export default LanguageSwitcher;
